
import React, { Component } from 'react';
import './add-teacher.scss'
import { Modal, ModalBody } from "reactstrap";

import SchoolApi from '../../../apis/school'
import Dropdown from '../../common/dropdown-v2/dropdown';
// import CommonApi from '../../../apis/common'
import { ImageConstants, } from '../../../constants/constants';
import { getImageSource } from '../../../utility/image-source'
import AddNewTeacher from '../../teachers/add-new-contact/add-new-contact';

class AddAdminComponent extends Component {
    constructor(props) {
        super(props)

    }



    state = {
        existingUsers: [],
        types: [],
        title: "Add Teacher",
        selectedUser: null,
        countryCodeDropdown: [],
        existingUsersDropdown: []
    }

    userHash = {}

    componentDidMount() {
        this.getStaffs()
    }


    getStaffs(payload = {}) {
        payload.types = `MATH_TEACHER`
        SchoolApi.getStaffs(payload)
            .then(response => {
                let items = [];
                this.userHash = {}
                for (let i = 0; i < response?.response?.length; i++) {
                    items.push({
                        title: response?.response[i].firstName,
                        value: response?.response[i]._id,
                    })
                    this.userHash[response?.response[i]._id] = response?.response[i]
                }

                this.setState({ existingUsersDropdown: items, reloadDropdown: true }, () => {
                    this.setState({ reloadDropdown: false })
                })
            }).catch(err => {
            })

    }

    onSave() {

        let payload = {
            _id: this.props.section?._id,
            teacher: this.state.selectedUser,
        }

        if (!this.validatePayload(payload)) return
        this.setState({ isSubmit: true })
        SchoolApi.updateSchoolSection(payload)
            .then(staffs => {
                this.props.onSave && this.props.onSave(true)
            }).catch(err => {
            })

    }

    validatePayload(payload) {
        if (!payload._id) {
            this.setState({ errorMessage: "Section id needed" })
            return false
        }
        if (!payload.teacher) {
            this.setState({ errorMessage: "Please select a teacher" })
            return false
        }
        this.setState({ errorMessage: "" })
        return true
    }

    addNewContact = () => {
        this.setState({ showAddNewTeacher: true })
    }

    onSelectUser = (option) => {
        if (option) {
            this.setState({ selectedUser: option?.value })
        } else {
            this.setState({ selectedUser: null })
        }

    }

    hideNewTeacher = (selectedTeacherId) => {
        if (selectedTeacherId) {
            this.setState({ showAddNewTeacher: false, selectedUser: selectedTeacherId })
        } else {
            this.setState({ showAddNewTeacher: false, })
        }
        this.getStaffs()
    }

    renderAddNewContactModal() {
        return (
            <Modal className="cw-custom-modal" isOpen={true} toggle={this.hideNewTeacher} size={"lg"}>
                <ModalBody >

                    <div className="row">
                        <div className="col text-right">
                            <img className="close-icon cursor-pointer" onClick={this.hideNewTeacher} src={getImageSource(ImageConstants.CROSS)} />
                        </div>
                    </div>
                    <div className="header-text text-center">
                        <span>{"ADD NEW TEACHER"}</span>
                    </div>
                    <div className="px-4">
                        <AddNewTeacher show={this.state.showAddNewTeacher} onClose={this.hideNewTeacher} size={'lg'} />
                    </div>
                </ModalBody>
            </Modal>)
    }


    render() {
        return (
            <Modal className="cw-custom-modal" isOpen={true} toggle={this.props.onClose} size={'md'}>

                <ModalBody >
                    <div className="add-teacher-class">
                        <div className="row">
                            <div className="col">
                                <img className="close-icon cursor-pointer" onClick={this.props.onClose} src={getImageSource(ImageConstants.CROSS)} />
                            </div>
                        </div>
                        <div className="text-center">
                            <span className="header-text ">{this.state.title}</span><br />
                            <span><b>to {this.props.section?.class} {this.props.section?.section}</b></span>
                        </div>

                        <div className='row pt-5'>
                            <div className='col-2'></div>
                            <div className='col-8'>
                                {
                                    !this.state.reloadDropdown ?
                                        <Dropdown
                                            key="users"
                                            placeholder='Select from the list'
                                            options={this.state.existingUsersDropdown}
                                            onSelect={(option) => this.onSelectUser(option)}
                                            text="title"
                                            style={{ background: "#F6F7F5" }}
                                            value={this.state.selectedUser}
                                            invalid={this.state.isSubmit && !this.state.selectedUser}
                                        />
                                        :
                                        ""
                                }
                            </div>
                            <div className='col-2 close-icon-wrapper'>
                                <img className="custom-close-icon cursor-pointer" onClick={this.addNewContact} src={getImageSource(ImageConstants.ADD)} />
                            </div>

                        </div>



                        <div className="text-center pt-5">
                            {
                                this.state.selectedUser ?
                                    <button className="cw-button-primary" onClick={() => this.onSave()}>
                                        ADD
                                    </button>
                                    :
                                    <button className="cw-button-disabled" >
                                        ADD
                                    </button>
                            }
                        </div>
                    </div>
                    {
                        this.state.showAddNewTeacher ? this.renderAddNewContactModal() : ""
                    }
                </ModalBody>

            </Modal >
        );
    }
}

export default AddAdminComponent;